export function padScore(n: number): string {
  return Math.max(0, Math.floor(n)).toString().padStart(6, "0");
}

export function hitPoints(reactionMs: number, approachMs: number, streak: number): {
  total: number;
  rapid: boolean;
} {
  const clamped = Math.max(80, Math.min(reactionMs, approachMs));
  const speed = 1 - clamped / approachMs;
  const rapid = reactionMs < 520;
  const streakBonus = Math.min(20, streak) * 12;
  const rapidBonus = rapid ? 180 : 0;
  const total = Math.round(100 + speed * 220 + streakBonus + rapidBonus);
  return { total, rapid };
}

export function hullPips(hull: number, max: number): string {
  const on = "■";
  const off = "□";
  return Array.from({ length: max }, (_, i) => (i < hull ? on : off)).join("");
}

export function speedBonus(elapsedMs: number): number {
  if (elapsedMs < 450) return 2.4;
  if (elapsedMs < 700) return 1.8;
  if (elapsedMs < 1100) return 1.35;
  if (elapsedMs < 1800) return 1.1;
  return 1;
}

export function comboPoints(elapsedMs: number, combo: number, wave: number): number {
  return Math.round(100 * combo * speedBonus(elapsedMs) * (1 + wave * 0.05));
}
